export class RubricStamp {
  stamp: string;
  signatoryId: string;
  fileName: string;
  page: string;
  positionX: number;
  positionY: number;
  positionPixelX: number;
  positionPixelY: number;
  sizePixelWidth: number = 50;
  sizePixelHeight: number = 46;
  sizeWidth: number = 14;
  sizeHeight: number = 12;
  invalid: boolean;
  gId: string;
  default: boolean = false;
}
